module.exports = __webpack_public_path__ + "static/img/7bg_11.fa870ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/7bg_11.png
// module id = 747
// module chunks = 1